import type { Resource } from '../../';
export const country_countries_HU: Resource = {"default":"Hungary"};
